import _unescape from 'lodash/unescape';

import type { FieldItemList, UserTaskModel } from 'models';
import { CheckIcon, ClearIcon } from 'components';

interface TaskList {
  info: FieldItemList[];
  description: FieldItemList<UserTaskModel>[];
}

export const taskList: TaskList = {
  info: [
    {
      id: 'Title',
      format: 'string',
      key: '##attribute#task#subject',
    },
    {
      id: 'CreatedOn',
      format: 'date',
      key: '##attribute#task#createdon',
    },
    {
      id: 'Space.Name',
      format: 'string',
      key: '##attribute#incident#uds_spaceid',
    },
    {
      id: 'ContactPerson.Name',
      format: 'string',
      key: '##attribute#contact#fullname',
    },
    {
      id: 'ContactPersonMobilePhone',
      format: 'string',
      key: '##attribute#contact#mobilephone',
    },
    {
      id: 'ContactPersonEmail',
      format: 'string',
      key: '##attribute#contact#emailaddress1',
    },
    {
      id: 'BuildingAddress',
      format: 'string',
      key: '##attribute#incident#uds_buildingaddress',
    },
    {
      id: 'BuildingPostalCode',
      format: 'string',
      key: '##attribute#incident#uds_buildingpostalcode',
    },
    {
      id: 'BuildingPostalArea',
      format: 'string',
      key: '##attribute#incident#uds_buildingpostalarea',
    },
    {
      id: 'IsMasterKeyAllowed',
      format: 'boolean',
      key: '##attribute#incident#uds_masterkeyallowed',
      variants: [<CheckIcon />, <ClearIcon />],
    },
    {
      id: 'IsRepairTimeNeedToBeAgreed',
      format: 'boolean',
      key: '##attribute#incident#uds_repairformneedtobeagreed',
      variants: [<CheckIcon />, <ClearIcon />],
    },
    {
      id: 'IsAppartmentHasAdditionalLock',
      format: 'boolean',
      key: '##attribute#incident#uds_appartmenthasadditionallock',
      variants: [<CheckIcon />, <ClearIcon />],
    },
  ],
  description: [
    {
      id: 'Description',
      format: 'string',
      key: '##attribute#task#description',
      render: (task) => task.Description && _unescape(task.Description),
    },
    {
      id: 'CustomerDescription',
      format: 'string',
      key: '##attribute#task#uds_customerdescription',
      render: (task) =>
        task.CustomerDescription && _unescape(task.CustomerDescription),
    },
  ],
};
